



























































































































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import FormInput from '@/components/FormInput.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Checkbox from '@/components/Checkbox.vue';
import TagInput from '@/components/TagInput.vue';
import Select2 from '@/components/Select2.vue';
import Button from '@/components/Button.vue';
import Select from '@/components/Select.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Toggle from '@/components/Toggle.vue';
import { ValidationObserver } from 'vee-validate';

import numberFormat from '@/libs/numberFormat';
import api from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

@Component({
  components: {
    FormInput,
    SearchField,
    SearchRow,
    Checkbox,
    TagInput,
    Select2,
    Button,
    Select,
    LayoutTitle,
    LayoutContent,
    Toggle,
    ValidationObserver,
  },
  methods: {
    numberFormat,
  },
})

export default class Content extends Vue {
  numberFormat!: (val: number) => string;
  loading = false;
  status = false;
  optionCountry: { label: string; value: string }[] = []
  optionCountryHR: { label: string; value: string }[] = []
  country: { label: string; value: string }[] = []
  countryOtp: { label: string; value: string }[] = []
  countryHR: { label: string; value: string }[] = [{ label: 'Indonesia', value: 'ID' }]
  missmatch = ''
  merchantCode = ''

  MinimumTicketSize = 100000
  MaximumTicketSize = 10000000
  DailyVolumeLimit = 10000000000
  MonthlyVolumeLimit = 10000000000
  CardNumberDay = 3
  CardNumberWeek = 5
  CardNumberMonth = 7
  emailDay = 3
  emailWeek = 5
  emailMonth = 7
  PhoneDay = 3
  PhoneWeek = 5
  PhoneMonth = 7
  RiskProbabilityScore = 50
  DailyCapture = true
  RejectMismatch = true
  RejectTransaction = true
  RejectProbable = true
  RejectMismatchBilling = true
  RejectMismatchIP = true
  RejectProbableEmail = true
  SendTrxReport = false
  SendTrxUser = false
  AllowCorporateCard = 0
  AllowTransactionFromHigh = '1'
  ReceiverEmail: { key: string; value: string }[] = []
  TrafficperMonth = ''
  AmountperMonth = ''

  errors = {
    MinimumTicketSize: '',
    MaximumTicketSize: '',
    DailyVolumeLimit: '',
    MonthlyVolumeLimit: '',
    CardNumberDay: '',
    CardNumberWeek: '',
    CardNumberMonth: '',
    emailDay: '',
    country: '',
    emailWeek: '',
    emailMonth: '',
    PhoneDay: '',
    PhoneWeek: '',
    PhoneMonth: '',
    RiskProbabilityScore: '',
    DailyCapture: '',
    RejectMismatch: '',
    RejectTransaction: '',
    RejectProbable: '',
    RejectMismatchBilling: '',
    RejectMismatchIP: '',
    RejectProbableEmail: '',
    SendTrxReport: '',
    SendTrxUser: '',
    AllowCorporateCard: '',
    AllowTransactionFromHigh: '',
    ReceiverEmail: '',
    TrafficperMonth: '',
    AmountperMonth: '',
  };

  async getCountry() {
    this.loading = true;
    const { data } = await api.get('/countries');
    this.optionCountry = data.map((e: any) => ({
      label: e.name,
      value: e.country_code,
    }));
    this.loading = false;
  }

  async getCountryHighrisk() {
    this.loading = true;
    const { data } = await api.get('/countries?is_highrisk=1');
    this.optionCountryHR = data.map((e: any) => ({
      label: e.name,
      value: e.country_code,
    }));
    this.loading = false;
  }

  async addFDs() {
    try {
      const fdsParams = {
        email_notification: this.ReceiverEmail.map((e) => e.value),
        min_ticket_size: this.MinimumTicketSize,
        max_ticket_size: this.MaximumTicketSize,
        daily_volume_limit: this.DailyVolumeLimit,
        monthly_volume_limit: this.MonthlyVolumeLimit,
        cardnum_day: this.CardNumberDay,
        cardnum_week: this.CardNumberWeek,
        cardnum_month: this.CardNumberMonth,
        email_day: this.emailDay,
        email_week: this.emailWeek,
        email_month: this.emailMonth,
        phone_day: this.PhoneDay,
        phone_week: this.PhoneWeek,
        phone_month: this.PhoneMonth,
        transaction_risk_score: this.RiskProbabilityScore,
        enable_daily_capture: this.DailyCapture ? 1 : 0,
        reject_mismatch_billing: this.RejectMismatch ? 1 : 0,
        reject_highrisk_country: this.AllowTransactionFromHigh,
        reject_proxy: this.RejectProbable ? 1 : 0,
        reject_mismatch_bil_bin_country: this.RejectMismatchBilling ? 1 : 0,
        allow_corporate_card: this.AllowCorporateCard ? 1 : 0,
        reject_highrisk_email: this.RejectProbableEmail ? 1 : 0,
        merchant_code: this.merchantCode,
        acceptance_country: this.countryHR.map((e) => e.value),
        country_otp: this.countryOtp.map((e) => e.value),
        report_receiver_email: this.ReceiverEmail.map((e) => e.value),
        transaction_traffic_avg_month: this.TrafficperMonth,
        transaction_amount_avg_mont: this.AmountperMonth,
        send_trx_report: this.SendTrxReport ? 1 : 0,
        send_trx_user: this.SendTrxUser ? 1 : 0,
      };
      this.$emit('modal', false);
      this.$emit('fds', fdsParams);
    } catch (err) {
      this.loading = false;
      showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data.error.errors.map((e: any) => e.message));
    }
  }

  mounted() {
    this.merchantCode = JSON.parse(localStorage.getItem('USER') || '{}').user.merchant.merchant_code;
    this.getCountry();
    this.getCountryHighrisk();
  }

  close() {
    this.$emit('modal', false);
  }
}
